import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {debounceTime, map, startWith, switchMap, tap} from 'rxjs/operators';
import {UnitGroupModel} from '../../../unit/unit-group/unit-group.model';
import {UnitGroupSearchService} from './unit-group-search.service';
import {UnitGroupsService} from '../unit-groups.service';

@Component({
  selector: 'app-add-unit-to-group',
  templateUrl: './add-unit-to-group.component.html',
  styleUrls: ['./add-unit-to-group.component.scss']
})
export class AddUnitToGroupComponent implements OnInit, OnDestroy {
  @Input() unitId: number;
  @Output() done: EventEmitter<'cancel' | 'success'> = new EventEmitter<'cancel' | 'success'>();
  formVisible = false;
  formGroup: FormGroup = new FormGroup({
    unitGroupId: new FormControl(undefined, [Validators.required]),
  });
  public keyField: string;
  public displayedField: string;
  public groups: BehaviorSubject<Array<UnitGroupModel> | null> = new BehaviorSubject<Array<UnitGroupModel> | null>(null);
  public loading = false;
  public typeahead = new Subject<string>();
  public typeaheadSubscription: Subscription;
  public selected: number | null;
  private requestActive = false;
  private readonly pageSize = 50;

  constructor(
    private unitGroupsService: UnitGroupsService,
    private unitGroupSearchService: UnitGroupSearchService,
    private notif: NotificationsService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.typeaheadSubscription = this.typeahead.pipe(
      startWith(''),
      debounceTime(500),
      switchMap(
        text => {
          this.loading = true;
          return this.unitGroupSearchService.getUnitGroupsAvailableToUnit(this.unitId, text);
        }
      ),
      tap(() => this.loading = false)
    ).subscribe(
      response => this.groups.next(response)
    );
    // this.executorPricePlanGroupListService.getPricePlanGroups(this.getExecutor().project_id).subscribe(
    //   pricePlanGroups => this.pricePlanGroups.next(pricePlanGroups)
    // );
  }

  ngOnDestroy() {
    [this.typeaheadSubscription].filter(s => !!s).forEach(s => s.unsubscribe());
  }

  closeFormEvent() {
    this.done.emit('cancel');
  }

  add() {
    if (this.formGroup.controls.unitGroupId.value && !this.requestActive) {
      this.requestActive = true;
      this.unitGroupsService.addUnitToGroup(
        this.unitId,
        this.formGroup.controls.unitGroupId.value
      ).subscribe(
        result => {
          this.requestActive = false;
          this.notif.success(this.translateService.instant('Unit has been added to group'));
          this.formVisible = false;
          this.done.emit('success');
        },
        error => {
          this.requestActive = false;
          this.notif.error('Server error');
        }
      );
    }
  }

  // onGroupSelectValueChange(value) {
  //   this.selected = value;
  // }
  // onClear() {
  //   this.selected = null;
  // }
}
